<template>
  <div class="row">
    <div class="col-xs-12">
      <div class="row">
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('contact.form.iban')" iban :required=required
                    :rules="{'required': required, 'alpha_num': true}" v-model="value.bankAccountIban"></text-box>
        </div>
        <div class="col-xs-12 col-md-6" v-if="isBicVisible">
          <masked-text-box :label="$t('contact.form.bic')" mask="XXXXSSXXXXX"
                           pattern="[0-9a-zA-Z]{4}[a-zA-Z]{2}[0-9a-zA-Z]{2}[0-9a-zA-Z]{0,3}"
                           required v-model="bicCode"></masked-text-box>
        </div>
      </div>
      <div class="row" v-if=withHolderName>
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('contact.form.accountHolderLastname')" :required=required :rules="{'required': required}"
                    v-model="value.bankAccountHolderLastName"></text-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('contact.form.accountHolderFirstname')" :required=required
                    :rules="{'required': required}"
                    v-model="value.bankAccountHolderFistName"></text-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import InputWithValidation from '@/components/inputs/Address/InputWithValidation'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { IbanInfo } from '@/models'

@Component
export default class ContactIbanInfos extends InputWithValidation {
  @Prop({ type: Object, required: true }) public readonly value!: IbanInfo
  @Prop({ type: Boolean, required: false, default: false }) public readonly required!: boolean
  @Prop({ type: Boolean, required: false, default: false }) public readonly withHolderName!: boolean

  public get isBicVisible(): boolean {
    return !!this.value.bankAccountIban
      && this.value.bankAccountIban.length > 1
      && !this.value.bankAccountIban.toLowerCase().startsWith('be')

  }

  get bicCode(): string {
    return this.value.bankAccountBic?.toUpperCase() ?? ''
  }

  set bicCode(val: string) {
    this.value.bankAccountBic = val.toUpperCase()
  }

  @Watch('isBicVisible')
  public OnBicVisibleChanged(value: boolean) {
    if (!value) {
      this.value.bankAccountBic = null
    }
  }
}
</script>

<style scoped>

</style>
